import { adminUiEn, adminUiId } from '@bak/admin-ui'

import { billingEn, billingId } from './billing.js'
import { commonEn, commonId } from './common.js'
import { domainsEn, domainsId } from './domains.js'
import { screensEn, screensId } from './screens.js'
import { siteDetailEn, siteDetailId } from './siteDetail.js'
import { shellEn, shellId } from './shell.js'
import { twoFactorEn, twoFactorId } from './twoFactor.js'

// English is the source of truth: a key missing from a translation is a type error, not a runtime gap.
export const en = { ...commonEn, ...shellEn, ...screensEn, ...siteDetailEn, ...domainsEn, ...twoFactorEn, ...billingEn, ...adminUiEn } as const
export type MessageKey = keyof typeof en
export const id: Record<MessageKey, string> = { ...commonId, ...shellId, ...screensId, ...siteDetailId, ...domainsId, ...twoFactorId, ...billingId, ...adminUiId }
